import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

// Image imports
import heroBg from "../../images/bg/hero_bg.png";
import heroIcon from "../../images/icon/animated-gif02.gif";
import featureIcon1 from "../../images/icon/feature-icon01.svg";
import featureIcon2 from "../../images/icon/feature-icon02.svg";
import featureIcon3 from "../../images/icon/feature-icon03.svg";

const featureIcons = [featureIcon1, featureIcon2, featureIcon3];

const HeroSection: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section
      className="hero hero-style pos-rel bg_img"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="container">
        <div className="row">
          {/* ---------- Left Content ---------- */}
          <div className="col-lg-9 col-md-9">
            <div className="hero-content">
              <h2 className="title scale-animation wow">
                {t.hero.title}
              </h2>
              <p className="sub-title scale-animation wow">
                {t.hero.subtitle}
              </p>
              <div className="hero-btn scale-animation wow">
                <Link className="thm-btn agency-btn" to="/contact">
                  <span className="text">{t.hero.ctaPrimary}</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      {[...Array(2)].map((_, i) => (
                        <svg
                          key={i}
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="5.06592"
                            y="19.9785"
                            width="20.5712"
                            height="2.61221"
                            transform="rotate(-40.2798 5.06592 19.9785)"
                            fill="white"
                          />
                          <rect
                            x="7.97095"
                            y="7.24463"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 7.97095 7.24463)"
                            fill="white"
                          />
                          <rect
                            x="11.6523"
                            y="7.54834"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 11.6523 7.54834)"
                            fill="white"
                          />
                          <rect
                            x="15.334"
                            y="7.85205"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 15.334 7.85205)"
                            fill="white"
                          />
                          <rect
                            x="18.7119"
                            y="11.8374"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.7119 11.8374)"
                            fill="white"
                          />
                          <rect
                            x="18.4084"
                            y="15.52"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.4084 15.52)"
                            fill="white"
                          />
                          <rect
                            x="18.104"
                            y="19.2012"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.104 19.2012)"
                            fill="white"
                          />
                        </svg>
                      ))}
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>

          {/* ---------- Right Icon ---------- */}
          <div className="col-lg-3 col-md-3">
            <div
              className="hero-icon wow zoomIn"
              data-wow-delay="700ms"
              data-wow-duration="800ms"
            >
              <img src={heroIcon} alt="AI icon" />
            </div>
          </div>
        </div>

        {/* ---------- Features ---------- */}
        <div className="row mt-55">
          {t.hero.features.map((feature, idx) => (
            <div className="col-lg-4 col-md-6 mt-30" key={idx}>
              <div
                className="xb-feature-item wow fadeInUp"
                data-wow-delay={`${700 + idx * 100}ms`}
                data-wow-duration="600ms"
              >
                <div className="xb-item--inner xb-border">
                  <span className="xb-item--icon">
                    <img src={featureIcons[idx] || featureIcon1} alt="feature icon" />
                  </span>
                  <div className="xb-item--holder">
                    <h2 className="xb-item--title">{feature.title}</h2>
                    <p className="xb-item--content">{feature.desc}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
